/**
 * Web stub for legacy kit lifecycle
 * The legacy app is iOS-only, so this is a no-op on web
 */
class LegacyKitLifecycle {
  initialize() {
    // No-op on web
  }

  cleanup() {
    // No-op on web
  }
}

export const legacyKitLifecycle = new LegacyKitLifecycle();
